module.exports = __webpack_public_path__ + "img/diameter.a1e0c7b1.svg";